import { Body, Icon, type IconType } from '@assembly-js/design-system';

interface GuidedModalOptionProps {
  icon: IconType;
  label: string;
  onClick: () => void;
}

/** A full-width choice row inside a guided modal: icon tile, label, chevron. */
export const GuidedModalOption = ({
  icon,
  label,
  onClick,
}: GuidedModalOptionProps) => (
  <button
    type="button"
    onClick={onClick}
    className="box-border flex h-13 w-full cursor-pointer appearance-none items-center gap-3 rounded-md border border-solid border-non-hover-border bg-white pl-2.5 pr-3 text-left transition-colors hover:bg-gray-100"
  >
    <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-gray-150 text-black-heading">
      <Icon icon={icon} aria-hidden="true" className="size-3.5" />
    </span>
    <Body tag="span" size="sm" className="flex-1 leading-5! text-black-heading">
      {label}
    </Body>
    <Icon
      icon="ChevronRight"
      aria-hidden="true"
      className="size-3 shrink-0 text-light-gray"
    />
  </button>
);
